var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefreshLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.0811,
    cy: 36.0811,
    r: 31.8311,
    stroke: "#CCCFD1",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9575 24.9152L42.191 18.3223L44.6058 17.6752L47.1241 27.0737L47.4476 28.2811L46.2402 28.6046L36.8417 31.1229L36.1947 28.7081L42.5597 27.0026C42.0123 26.5449 41.4181 26.1279 40.7789 25.7589C34.8003 22.3071 27.1554 24.3556 23.7036 30.3342C20.2518 36.3129 22.3003 43.9578 28.2789 47.4095C34.2576 50.8613 41.9025 48.8129 45.3542 42.8342C46.2441 41.293 46.7684 39.641 46.9541 37.9786L49.4676 37.9786C49.274 40.0673 48.6369 42.1485 47.5193 44.0842C43.3772 51.2586 34.2033 53.7167 27.0289 49.5746C19.8545 45.4325 17.3964 36.2586 21.5385 29.0842C25.6807 21.9098 34.8545 19.4517 42.0289 23.5938C42.7155 23.9903 43.359 24.4328 43.9575 24.9152Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefreshLine);
export default __webpack_public_path__ + "static/media/icon-refresh-line.47c08223a8867a1fc0d3b59dbb649ab3.svg";
export { ForwardRef as ReactComponent };